export default "__VITE_ASSET__3tnI96af__"